import { render, staticRenderFns } from "./MentionList.vue?vue&type=template&id=435b90b7&"
import script from "./MentionList.vue?vue&type=script&lang=js&"
export * from "./MentionList.vue?vue&type=script&lang=js&"
import style0 from "./MentionList.vue?vue&type=style&index=0&id=435b90b7&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports